module.exports = __webpack_public_path__ + "img/commend3.99e7f2e2.png";